import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const formatUserLocation = user => {
  const { city, regionName, countryName } = user.location;
  return [city, regionName, countryName]
    .filter(item => item != null)
    .slice(0, 2)
    .join(', ');
};

const usersContentPrivacyPolicy = (context, contentType) => {
  if (!context.currentUser) return;

  return context.currentUser.privacyPolicy?.content[contentType]?.visibility;
};

const userCanEdit = ({ currentUser, adminUser, mobileBrowser }, dataUser, isMobileEditable) => {
  if (mobileBrowser && !isMobileEditable) {
    return false;
  }

  if (adminUser) {
    return adminUser;
  }

  if (currentUser && dataUser) {
    return currentUser.id === dataUser.id;
  }

  return dataUser == null || dataUser.username === StringConstantsMixin.constants.MAGIC.ANONYMOUS_MAP_USERNAME;
};

const isAnotherMemberView = (currentUser, dataUser) => currentUser && dataUser?.id !== currentUser?.id;

export { formatUserLocation, usersContentPrivacyPolicy, userCanEdit, isAnotherMemberView };
